module.exports = __webpack_public_path__ + "static/media/traveler.38499b0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/commanders/traveler.png
// module id = 2061
// module chunks = 0